import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { AccesoriosInterface } from "../../../../interfaces/AccesoriosInterface";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

//estilos
const classes = require("./AccesoriosEdit.module.css").default;

/**
 * UusarioEdit Component
 * @description: Componente que permite editar un accesorio.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de accesorioss.
 */

const AccesoriosEdit = () => {
  const { idAccesorio } = useParams();
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();
  const [accesorios, setAccesorios] = useState<AccesoriosInterface>();
  const [show, setShow] = useState(false);

  //Variables de formulario
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: accesorios?.nombre,
    },
  });

  //Función que trata el detalle de accesorios.
  const transformData = useCallback(
    (variable: any) => {
      setAccesorios(variable.data);
      reset(variable.data);
    },
    [reset]
  );

  //Se recibe el accesorios a editar
  useEffect(() => {
    sendRequest(
      {
        url: `/accesorio/${idAccesorio}`,
      },
      transformData
    );
  }, [idAccesorio, sendRequest, transformData]);

  //Función que solicita la edición del accesorios
  const updateAccesorios = (data: any) => {
    sendRequest(
      {
        url: `/accesorio/${idAccesorio}`,
        method: "PATCH",
        body: data,
      },
      (variable: any) => {
        setShow(true);
      }
    );
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!accesorios) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Edición de accesorio {idAccesorio}</h2>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Accesorio actualizado"
          body="El accesorio ha sido actualizado de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(updateAccesorios)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 200,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 200 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default AccesoriosEdit;
